






import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'examples-tool',

})
export default class ExamplesTool extends Vue {

}
